import React, { Component, PropTypes } from "react";
import ReactDOM from "react-dom";
import assign from "object-assign";
import { FullRow, Row, Col } from "../framework/Grid";
import { Popover } from "material-ui";
import {
  withGoogleMap,
  GoogleMap,
  Circle,
  Polygon,
  Rectangle,
} from "react-google-maps";
import { getMapVectorOptions } from "../../utils/utility";

import { map, last, isUndefined, isEmpty } from "lodash";
import Tree, { TreeNode } from "rc-tree";
import Tooltip from "rc-tooltip";
import { splitNumber } from "../../utils/utility";
import { Checkbox } from "material-ui";

import "rc-tree/assets/index.css";
import "./selected_attrs.css";
import "rc-tree/assets/index.css";

const google = window.google;
class SelectedAttrs extends Component {
  componentWillMount() {
    this.state = {
      removeValConfirm: false,
      stateObj: "",
      cityObj: "",
      dmaObj: "",
      countyObj: "",
      ifRemoveState: false,
      ifRemoveCity: false,
      ifRemoveCounty: false,
      ifRemoveDMA: false,
      ifRemoveAllState: false,
      ifRemoveAllCity: false,
      ifRemoveAllStateAndCity: false,
      ifRemoveAllCounty: false,
      ifRemoveAllDMA: false,
      stateAndCityPageY: "",
      ifShowChannel: false,
      ifRemoveAllZipCode: false,
      ifRemoveZipCode: false,
      zipcode: "",
    };
  }
  componentDidMount() {
    this.getContainer();
  }
  componentWillUnmount() {
    if (this.cmContainer) {
      ReactDOM.unmountComponentAtNode(this.cmContainer);
      document.body.removeChild(this.cmContainer);
      this.cmContainer = null;
    }
  }

  getContainer() {
    if (!this.cmContainer) {
      this.cmContainer = document.createElement("div");
      document.body.appendChild(this.cmContainer);
    }
    return this.cmContainer;
  }

  renderCm(info, audiences) {
    if (this.toolTip) {
      if (this.cmContainer) ReactDOM.unmountComponentAtNode(this.cmContainer);
      this.toolTip = null;
    }
    const over_lay = (
      <div>
        <FullRow>Reach by Channel</FullRow>
        <Row className="no-padding">
          <Col xs="4" sm="4" md="4" lg="4" style={{ paddingLeft: 0 }}>
            <p>
              <i
                className="icon-envelope"
                style={{ fontSize: "1.5em", marginRight: "0.4em" }}
              />
              <span className="ml-8 text-default text-bold">
                {splitNumber(audiences.email + "")()}
              </span>
            </p>
          </Col>
          <Col xs="4" sm="4" md="4" lg="4" style={{ paddingLeft: 0 }}>
            <p>
              <i
                className="icon-share3"
                style={{ fontSize: "1.5em", marginRight: "0.4em" }}
              />
              <span className="ml-8 text-default text-bold">
                {splitNumber(audiences.social + "")()}
              </span>
            </p>
          </Col>
          <Col xs="4" sm="4" md="4" lg="4" style={{ paddingRight: 0 }}>
            <p className="pull-left">
              <i
                className="icon-display4"
                style={{ fontSize: "1.5em", marginRight: "0.4em" }}
              />
              <span className="ml-8 text-default text-bold">
                {splitNumber(audiences.display + "")()}
              </span>
            </p>
          </Col>
        </Row>
      </div>
    );
    this.toolTip = (
      <Tooltip
        trigger="click"
        placement="right"
        prefixCls="rc-tree-contextmenu"
        mouseEnterDelay={0.5}
        defaultVisible
        overlay={over_lay}
      >
        <span></span>
      </Tooltip>
    );

    const container = this.getContainer();
    const { width } = this.props;
    const top = info.pageY ? info.pageY : info.event.pageY;
    const posX = width ? width / 3.2 : info.event.pageX;
    assign(this.cmContainer.style, {
      position: "absolute",
      left: `${posX}px`,
      top: `${top}px`,
    });

    ReactDOM.render(this.toolTip, container);
  }

  displayPlottedRadiusAudience(info) {
    const { width } = this.props;
    if (info.event.pageX > width / 3) return;
    if (this.cmContainer != null) {
      ReactDOM.unmountComponentAtNode(this.cmContainer);
      document.body.removeChild(this.cmContainer);
      this.cmContainer = null;
    }
    this.renderCm(info, this.props.plottedRadius.audienceCount);
  }

  displayAttrAudience(info, categories, slt_vals) {
    const { width } = this.props;
    if (info.event.pageX > width / 3) return;

    if (this.cmContainer != null) {
      ReactDOM.unmountComponentAtNode(this.cmContainer);
      document.body.removeChild(this.cmContainer);
      this.cmContainer = null;
    }
    const id = last(info.node.props.eventKey.split("-"));
    const audiences = { email: 0, social: 0, display: 0 };
    if (info.node.props.isLeaf === true) {
      map(categories, (cat) => {
        map(cat.attributes, (attr) => {
          map(attr.values, (val) => {
            if (parseInt(val.id, 10) === parseInt(id, 10)) {
              audiences.email = val.email;
              audiences.display = val.display;
              audiences.social = val.social;
            }
          });
          map(attr.subAttributes, (subAttr) => {
            map(subAttr.values, (val) => {
              if (parseInt(val.id, 10) === parseInt(id, 10)) {
                audiences.email = val.email;
                audiences.display = val.display;
                audiences.social = val.social;
              }
            });
          });
        });
      });
    }
    if (isUndefined(info.node.props.isLeaf)) {
      map(categories, (cat) => {
        map(cat.attributes, (attr) => {
          if (parseInt(attr.id, 10) === parseInt(id, 10)) {
            map(attr.values, (val) => {
              if (slt_vals.indexOf(val.id) >= 0) {
                audiences.email += val.email;
                audiences.display += val.display;
                audiences.social += val.social;
              }
            });
            map(attr.subAttributes, (subAttr) => {
              map(subAttr.values, (val) => {
                if (slt_vals.indexOf(val.id) >= 0) {
                  audiences.email += val.email;
                  audiences.display += val.display;
                  audiences.social += val.social;
                }
              });
            });
          }
        });
      });
    }

    this.renderCm(info, audiences);
  }

  onConfirmBtnMouseOver() {
    if (this.cmContainer != null) {
      ReactDOM.unmountComponentAtNode(this.cmContainer);
      document.body.removeChild(this.cmContainer);
      this.cmContainer = null;
    }
  }

  onMouseLeave(info) {
    if (this.cmContainer != null) {
      ReactDOM.unmountComponentAtNode(this.cmContainer);
      document.body.removeChild(this.cmContainer);
      this.cmContainer = null;
    }
  }

  removeSelectVal() {
    if (this.state.sltId >= 0) {
      if (this.state.removeType === "val") {
        this.props.removeAttribute(this.state.sltId);
      }
      if (this.state.removeType === "attr") {
        const { categories, selectedAttrs } = this.props;
        map(categories, (cat, key) => {
          map(cat.attributes, (attr) => {
            if (attr.id === this.state.sltId) {
              map(attr.values, (val) => {
                if (selectedAttrs.indexOf(val.id) >= 0) {
                  this.props.removeAttribute(val.id);
                }
              });

              map(attr.subAttributes, (subAttr) => {
                map(subAttr.values, (val) => {
                  if (selectedAttrs.indexOf(val.id) >= 0) {
                    this.props.removeAttribute(val.id);
                  }
                });
              });
            }
          });
        });
      }
      if (this.state.removeType === "plotted_radius") {
        this.props.removePlottedVal();
      }
      this.setState({ sltId: null });
    }

    if (
      this.props.selected_city.length > 0 ||
      this.props.selected_state.length > 0 ||
      this.props.selected_county.length > 0 ||
      this.props.selected_dma.length > 0 ||
      this.props.zipcode.length > 0
    ) {
      if (this.state.ifRemoveState) {
        this.props.selectState(this.state.stateObj, false);
        this.setState({
          ifRemoveState: false,
        });
      } else if (this.state.ifRemoveCity) {
        this.props.selectCity(this.state.cityObj, false);
        this.setState({
          ifRemoveCity: false,
        });
      } else if (this.state.ifRemoveCounty) {
        this.props.selectCounty(this.state.countyObj, false);
        this.setState({
          ifRemoveCounty: false,
        });
      } else if (this.state.ifRemoveDMA) {
        this.props.selectDMA(this.state.dmaObj, false);
        this.setState({
          ifRemoveDMA: false,
        });
      } else if (this.state.ifRemoveAllState) {
        this.props.clearAllSelectedState();
        this.setState({
          ifRemoveAllState: false,
        });
      } else if (this.state.ifRemoveAllCity) {
        this.props.clearAllSelectedCity();
        this.setState({
          ifRemoveAllCity: false,
        });
      } else if (this.state.ifRemoveAllStateAndCity) {
        this.props.clearAllSelectedCity();
        this.props.clearAllSelectedState();
        this.props.clearAllZipCode();
        this.setState({
          ifRemoveAllStateAndCity: false,
        });
      } else if (this.state.ifRemoveAllZipCode) {
        this.props.clearAllZipCode();
        this.setState({
          ifRemoveAllZipCode: false,
        });
      } else if (this.state.ifRemoveZipCode) {
        this.props.clearZipCode(this.state.zipcode.zipcode);
        this.setState({
          ifRemoveZipCode: false,
        });
      } else if (this.state.ifRemoveAllCounty) {
        this.props.clearAllCounty();
        this.setState({
          ifRemoveAllCounty: false,
        });
      } else if (this.state.ifRemoveAllDMA) {
        this.props.clearAllDMA();
        this.setState({
          ifRemoveAllDMA: false,
        });
      }
    }
  }

  removeValBtn(id) {
    return this.props.listMode === true ? (
      ""
    ) : (
      <a
        onClick={(e) => {
          e.preventDefault();
          this.setState({
            sltId: id,
            removeType: "val",
            removeValConfirm: true,
            anchorEl: e.currentTarget,
          });
        }}
      >
        <i className="icon-cancel-circle2 text-teal-400" />
      </a>
    );
  }

  removeAttrValBtn(id) {
    return this.props.listMode === true ? (
      ""
    ) : (
      <a
        onClick={(e) => {
          e.preventDefault();
          this.setState({
            sltId: id,
            removeType: "attr",
            removeValConfirm: true,
            anchorEl: e.currentTarget,
          });
        }}
      >
        <i className="icon-cancel-circle2 text-teal-400" />
      </a>
    );
  }

  removePlottedValBtn() {
    return (
      <a
        onClick={(e) => {
          e.preventDefault();
          this.setState({
            sltId: 0,
            removeType: "plotted_radius",
            removeValConfirm: true,
            anchorEl: e.currentTarget,
          });
        }}
      >
        <i className="icon-cancel-circle2 text-teal-400" />
      </a>
    );
  }

  handleRemoveValConfirm() {
    this.setState({
      removeValConfirm: false,
      anchorEl: null,
    });
  }

  removeStateAttribute(e, stateObj) {
    e.preventDefault();
    this.setState({
      removeValConfirm: true,
      anchorEl: e.currentTarget,
      stateObj: stateObj,
      ifRemoveState: true,
    });
  }
  removeCityAttribute(e, cityObj) {
    e.preventDefault();
    this.setState({
      removeValConfirm: true,
      anchorEl: e.currentTarget,
      cityObj: cityObj,
      ifRemoveCity: true,
    });
  }
  removeDMA(e, obj) {
    e.preventDefault();
    this.setState({
      removeValConfirm: true,
      anchorEl: e.currentTarget,
      dmaObj: obj,
      ifRemoveDMA: true,
    });
  }
  removeCounty(e, obj) {
    e.preventDefault();
    this.setState({
      removeValConfirm: true,
      anchorEl: e.currentTarget,
      countyObj: obj,
      ifRemoveCounty: true,
    });
  }
  removeAllState(e) {
    e.preventDefault();
    this.setState({
      removeValConfirm: true,
      anchorEl: e.currentTarget,
      ifRemoveAllState: true,
    });
  }
  removeAllCity(e) {
    e.preventDefault();
    this.setState({
      removeValConfirm: true,
      anchorEl: e.currentTarget,
      ifRemoveAllCity: true,
    });
  }
  removeAllCounty(e) {
    e.preventDefault();
    this.setState({
      removeValConfirm: true,
      anchorEl: e.currentTarget,
      ifRemoveAllCounty: true,
    });
  }
  removeAllDMA(e) {
    e.preventDefault();
    this.setState({
      removeValConfirm: true,
      anchorEl: e.currentTarget,
      ifRemoveAllDMA: true,
    });
  }
  removeAllStateAndCity(e) {
    e.preventDefault();
    this.setState({
      removeValConfirm: true,
      anchorEl: e.currentTarget,
      ifRemoveAllStateAndCity: true,
    });
  }
  removeAllZipCode(e) {
    e.preventDefault();
    this.setState({
      removeValConfirm: true,
      anchorEl: e.currentTarget,
      ifRemoveAllZipCode: true,
    });
  }
  removeZipCode(e, zipcode) {
    e.preventDefault();
    this.setState({
      removeValConfirm: true,
      anchorEl: e.currentTarget,
      zipcode: zipcode,
      ifRemoveZipCode: true,
    });
  }
  showChannel(e) {
    let attr = e.event.target.getAttribute("data-type");
    let obj = {};
    const idx = e.event.target.getAttribute("data-index");
    var email, social, display;
    if (attr !== null) {
      if (attr === "state/city") {
        email =
          this.props.selected_state.reduce((acc, curr) => acc + curr.email, 0) +
          this.props.selected_city.reduce((acc, curr) => acc + curr.email, 0) +
          this.props.zipcode.reduce((acc, curr) => acc + curr.email, 0);
        social =
          this.props.selected_state.reduce(
            (acc, curr) => acc + curr.social,
            0,
          ) +
          this.props.selected_city.reduce((acc, curr) => acc + curr.social, 0) +
          this.props.zipcode.reduce((acc, curr) => acc + curr.social, 0);
        display =
          this.props.selected_state.reduce(
            (acc, curr) => acc + curr.display,
            0,
          ) +
          this.props.selected_city.reduce(
            (acc, curr) => acc + curr.display,
            0,
          ) +
          this.props.zipcode.reduce((acc, curr) => acc + curr.display, 0);
      } else if (attr === "state") {
        email = this.props.selected_state.reduce(
          (acc, curr) => acc + curr.email,
          0,
        );
        social = this.props.selected_state.reduce(
          (acc, curr) => acc + curr.social,
          0,
        );
        display = this.props.selected_state.reduce(
          (acc, curr) => acc + curr.display,
          0,
        );
      } else if (attr === "city") {
        email = this.props.selected_city.reduce(
          (acc, curr) => acc + curr.email,
          0,
        );
        social = this.props.selected_city.reduce(
          (acc, curr) => acc + curr.social,
          0,
        );
        display = this.props.selected_city.reduce(
          (acc, curr) => acc + curr.display,
          0,
        );
      } else if (attr === "stateChild") {
        email = this.props.selected_state[idx].email;
        social = this.props.selected_state[idx].social;
        display = this.props.selected_state[idx].display;
      } else if (attr === "cityChild") {
        email = this.props.selected_city[idx].email;
        social = this.props.selected_city[idx].social;
        display = this.props.selected_city[idx].display;
      } else if (attr === "zipcode") {
        email = this.props.zipcode.reduce((acc, curr) => acc + curr.email, 0);
        social = this.props.zipcode.reduce((acc, curr) => acc + curr.social, 0);
        display = this.props.zipcode.reduce(
          (acc, curr) => acc + curr.display,
          0,
        );
      } else if (attr === "zipcodeitem") {
        email = this.props.zipcode[idx].email;
        social = this.props.zipcode[idx].social;
        display = this.props.zipcode[idx].display;
      } else if (attr === "county") {
        email = this.props.selected_county.reduce(
          (acc, curr) => acc + curr.email,
          0,
        );
        social = this.props.selected_county.reduce(
          (acc, curr) => acc + curr.social,
          0,
        );
        display = this.props.selected_county.reduce(
          (acc, curr) => acc + curr.display,
          0,
        );
      } else if (attr === "dma") {
        email = this.props.selected_dma.reduce(
          (acc, curr) => acc + curr.email,
          0,
        );
        social = this.props.selected_dma.reduce(
          (acc, curr) => acc + curr.social,
          0,
        );
        display = this.props.selected_dma.reduce(
          (acc, curr) => acc + curr.display,
          0,
        );
      } else if (attr === "countyItem") {
        email = this.props.selected_county[idx].email;
        social = this.props.selected_county[idx].social;
        display = this.props.selected_county[idx].display;
      } else if (attr === "dmaItem") {
        email = this.props.selected_dma[idx].email;
        social = this.props.selected_dma[idx].social;
        display = this.props.selected_dma[idx].display;
      }
      obj.email = email;
      obj.social = social;
      obj.display = display;
      this.renderCm(e, obj);
    }
  }
  handleMapMounted(map) {
    this._map = map;
    if (this._map && this._vector)
      try {
        this._map.fitBounds(this._vector.getBounds());
      } catch (ex) {}
  }

  plotted_radius_row() {
    const { plottedRadius } = this.props;
    if (isEmpty(plottedRadius)) {
      return <div />;
    } else {
      let vector = null;
      switch (plottedRadius.type) {
        case "polygon":
          vector = (
            <Polygon
              ref={(elm) => (this._vector = elm)}
              path={
                typeof plottedRadius.path === "string"
                  ? google.maps.geometry.encoding.decodePath(plottedRadius.path)
                  : plottedRadius.path
              }
              options={getMapVectorOptions()}
            />
          );
          break;
        case "rectangle":
          vector = (
            <Rectangle
              ref={(elm) => (this._vector = elm)}
              bounds={plottedRadius.bounds}
              radius={plottedRadius.radius}
              options={getMapVectorOptions()}
            />
          );
          break;
        case "circle":
          //default:
          vector = (
            <Circle
              ref={(elm) => (this._vector = elm)}
              center={plottedRadius.center}
              radius={plottedRadius.radius}
              options={getMapVectorOptions()}
            />
          );
          break;
        default:
          vector = "";
          break;
      }
      let PlottedRadiusMap = null;
      if (vector) {
        PlottedRadiusMap = withGoogleMap((props) => (
          <GoogleMap
            zoom={plottedRadius.zoom}
            center={plottedRadius.center}
            defaultOptions={{
              streetViewControl: false,
              mapTypeControl: false,
              zoomControl: false,
              scrollwheel: false,
              draggable: false,
            }}
            ref={this.handleMapMounted.bind(this)}
          >
            {vector}
          </GoogleMap>
        ));
      }

      const { selected_state, selected_city } = this.props;
      const showTitle = !(
        selected_state.length > 0 || selected_city.length > 0
      );
      return [
        showTitle && (
          <FullRow
            key="geo_header_row"
            style={{ marginTop: "-20px", marginBottom: "-10px" }}
            className="no-padding-bottom no-padding-top no-margin-bottom no-margin-top"
          >
            <h4 style={{ marginBottom: "0px" }}>GEOGRAPHIC</h4>
          </FullRow>
        ),
        <Row
          key="plotted-radius-row"
          className="no-padding-left no-margin-bottom no-padding-bottom no-padding-right pt-5 city-state-container"
          style={{
            width: this.props.listMode === true ? "103%" : "80%",
            marginLeft: "20px",
          }}
        >
          <Col
            xs="9"
            md="9"
            sm="9"
            lg="9"
            className="no-padding-left no-padding-right"
            style={{ overflow: "hidden" }}
          >
            <div
              style={{ float: "left" }}
              className="text-teal-400 text-capitalize"
            >
              <span>plotted radius&nbsp;&nbsp;&nbsp;</span>
            </div>
            <div
              onMouseOver={this.onConfirmBtnMouseOver.bind(this)}
              style={{
                marginTop: "-10px",
                overflow: "hidden",
                borderBottom: "1px gray dashed",
              }}
            >
              &nbsp;
            </div>
          </Col>
          <Col
            xs="2"
            md="2"
            sm="2"
            lg="2"
            className="text-right no-padding-left no-padding-right"
            style={{ overflow: "hidden" }}
            onMouseOver={this.onConfirmBtnMouseOver.bind(this)}
          >
            <div
              style={{
                marginTop: "-10px",
                overflow: "hidden",
                borderBottom: "1px gray dashed",
              }}
            >
              &nbsp;&nbsp;&nbsp;
            </div>
          </Col>
          <Col xs="1" sm="1" md="1" lg="1" className="no-padding-right pl-20">
            {this.props.listMode === true ? null : this.removePlottedValBtn()}
          </Col>
        </Row>,
        PlottedRadiusMap ? (
          <Row
            className="geo-map-row-container"
            key="geo_map_row"
            style={{ paddingTop: "5px" }}
          >
            <Col
              xs="8"
              sm="8"
              md="8"
              lg="8"
              style={{
                height: "250px",
                paddingRight: "40px",
                maxWidth: "700px",
              }}
            >
              <PlottedRadiusMap
                containerElement={<div style={{ height: `100%` }} />}
                mapElement={<div style={{ height: `100%` }} />}
              />
            </Col>
          </Row>
        ) : (
          <div
            key="address_map_container"
            style={{ width: this.props.listMode === true ? "103%" : "80%" }}
          >
            <Row
              key="geo_map_address_row"
              id="geo_map_address_row"
              className="no-margin-bottom no-padding-bottom no-padding-right"
              style={{ paddingTop: "5px", paddingLeft: "60px" }}
            >
              <Col
                xs="1"
                sm="1"
                md="1"
                lg="1"
                offsetXs="1"
                offsetSm="1"
                offsetMd="1"
                offsetLg="1"
                className="no-padding-right"
              >
                <div style={{ float: "left" }}>
                  <span>Address</span>&nbsp;&nbsp;&nbsp;
                </div>
                <div
                  style={{
                    marginTop: "-10px",
                    overflow: "hidden",
                    borderBottom: "0px gray dashed",
                  }}
                >
                  &nbsp;
                </div>
              </Col>
              <Col
                xs="8"
                sm="8"
                md="8"
                lg="8"
                className="text-right no-padding-right"
              >
                <div style={{ float: "right" }}>
                  <div style={{ maxWidth: "460px", whiteSpace: "pre-wrap" }}>
                    &nbsp;&nbsp;
                    {plottedRadius.addressLabel.replace(", United States", "")}
                  </div>
                </div>
                <div
                  style={{
                    marginTop: "-10px",
                    overflow: "hidden",
                    borderBottom: "1px gray dashed",
                  }}
                >
                  &nbsp;
                </div>
              </Col>
            </Row>
            <Row
              key="geo_map_address_role_row"
              className="no-margin-bottom no-padding-bottom no-padding-right"
              style={{ paddingTop: "5px", paddingLeft: "60px" }}
            >
              <Col
                xs="7"
                sm="7"
                md="7"
                lg="7"
                offsetXs="1"
                offsetSm="1"
                offsetMd="1"
                offsetLg="1"
                className="no-padding-right"
              >
                <div style={{ float: "left" }}>
                  <span>
                    {plottedRadius.type === "address_radius"
                      ? "Radius from Address"
                      : "Drive Time from Address"}
                  </span>
                  &nbsp;&nbsp;&nbsp;
                </div>
                <div
                  style={{
                    marginTop: "-10px",
                    overflow: "hidden",
                    borderBottom: "1px gray dashed",
                  }}
                >
                  &nbsp;
                </div>
              </Col>
              <Col
                xs="2"
                sm="2"
                md="2"
                lg="2"
                className="text-right no-padding-right no-padding-left"
              >
                <div style={{ float: "right" }}>
                  &nbsp;&nbsp;
                  {plottedRadius.type === "address_radius"
                    ? plottedRadius.radius + " Mile(s)"
                    : plottedRadius.driveTime + " Hour(s)"}
                </div>
                <div
                  style={{
                    marginTop: "-10px",
                    overflow: "hidden",
                    borderBottom: "1px gray dashed",
                  }}
                >
                  &nbsp;
                </div>
              </Col>
            </Row>
          </div>
        ),
      ];
    }
  }

  display_geography() {
    const {
      selected_state,
      selected_city,
      selected_county,
      selected_dma,
      zipcode,
      listMode,
    } = this.props;
    if (
      selected_state.length > 0 ||
      selected_city.length > 0 ||
      zipcode.length > 0 ||
      selected_county.length > 0 ||
      selected_dma.length > 0
    ) {
      return (
        <div className="state-city-tree " style={{ position: "relative" }}>
          <FullRow className="no-padding-bottom no-margin-bottom  no-padding-top no-margin-top">
            <h4 style={{ marginBottom: "0px" }}>GEOGRAPHY</h4>
          </FullRow>
          <Tree
            showIcon={false}
            selectable={false}
            showLine={false}
            checkable={false}
            defaultExpandAll={false}
            onMouseEnter={(e) => this.showChannel(e)}
            onMouseLeave={this.onMouseLeave.bind(this)}
          >
            <TreeNode
              title={
                <Row className="no-margin-left no-margin-bottom no-padding-bottom no-padding-left no-padding-right pt-5">
                  <Col
                    xs="9"
                    md="9"
                    sm="9"
                    lg="9"
                    className="no-padding-right"
                    style={{ overflow: "hidden" }}
                  >
                    <div style={{ float: "left" }} data-type="state/city">
                      <span className="text-teal-400">
                        {zipcode.length > 0 ? "US Zip Code" : "US State/City"}
                      </span>
                      <span>
                        (
                        {zipcode.length > 0
                          ? zipcode.length
                          : selected_state.length + selected_city.length}
                        )
                      </span>
                      &nbsp;
                    </div>
                    <div
                      onMouseOver={this.onConfirmBtnMouseOver.bind(this)}
                      style={{
                        marginTop: "-10px",
                        overflow: "hidden",
                        borderBottom: "1px gray dashed",
                      }}
                    >
                      &nbsp;
                    </div>
                  </Col>
                  <Col
                    xs="2"
                    md="2"
                    sm="2"
                    lg="2"
                    style={{ overflow: "hidden" }}
                    className="text-right no-padding-right no-padding-left"
                    onMouseOver={this.onConfirmBtnMouseOver.bind(this)}
                  >
                    <div
                      style={{
                        marginTop: "-10px",
                        overflow: "hidden",
                        borderBottom: "1px gray dashed",
                      }}
                    >
                      &nbsp;
                    </div>
                  </Col>
                  <Col
                    xs="1"
                    md="1"
                    sm="1"
                    lg="1"
                    style={{
                      paddingLeft: "15px",
                      display: listMode === true ? "none" : "block",
                    }}
                  >
                    <a
                      onClick={(e) =>
                        zipcode.length > 0
                          ? this.removeAllZipCode(e)
                          : this.removeAllStateAndCity(e)
                      }
                    >
                      <i className="icon-cancel-circle2 text-teal-400" />
                    </a>
                  </Col>
                </Row>
              }
              className={
                selected_county.length > 0 || selected_dma.length > 0
                  ? "hidden-us-state"
                  : this.props.listMode === true
                  ? "width-128"
                  : ""
              }
            >
              <TreeNode
                className={selected_state.length > 0 ? "" : "hidden-state"}
                title={
                  <Row
                    style={{ paddingTop: "2px" }}
                    className="no-margin-left no-margin-bottom no-padding-bottom no-padding-left pr-5"
                  >
                    <Col
                      xs="9"
                      md="9"
                      sm="9"
                      lg="9"
                      className="no-padding-right"
                      style={{ overflow: "hidden" }}
                    >
                      <div style={{ float: "left" }} data-type="state">
                        <span className="text-teal-400">State</span>
                        <span>({selected_state.length})</span>
                        &nbsp;&nbsp;&nbsp;
                      </div>
                      <div
                        style={{
                          marginTop: "-10px",
                          overflow: "hidden",
                          borderBottom: "1px gray dashed",
                        }}
                      >
                        &nbsp;
                      </div>
                    </Col>
                    <Col
                      xs="2"
                      md="2"
                      sm="2"
                      lg="2"
                      className="text-right no-padding-right no-padding-left"
                      style={{ overflow: "hidden" }}
                      onMouseOver={this.onConfirmBtnMouseOver.bind(this)}
                    >
                      <div
                        style={{
                          marginTop: "-10px",
                          overflow: "hidden",
                          borderBottom: "1px gray dashed",
                        }}
                      >
                        &nbsp;
                      </div>
                    </Col>
                    <Col
                      xs="1"
                      sm="1"
                      md="1"
                      lg="1"
                      style={{
                        paddingLeft: "15px",
                        display: listMode === true ? "none" : "block",
                      }}
                    >
                      <a onClick={(e) => this.removeAllState(e)}>
                        <i className="icon-cancel-circle2 text-teal-400" />
                      </a>
                    </Col>
                  </Row>
                }
              >
                {selected_state.map((item, index) => (
                  <TreeNode
                    title={
                      <Row
                        style={{ paddingTop: "2px" }}
                        className="no-margin-bottom no-padding-bottom no-margin-left no-padding-left pr-5"
                      >
                        <Col
                          xs="9"
                          md="9"
                          sm="9"
                          lg="9"
                          className="no-padding-right"
                          style={{ overflow: "hidden" }}
                        >
                          <div
                            className="text-teal-400"
                            data-type="stateChild"
                            data-index={index}
                            style={{ display: "flex", float: "left" }}
                          >
                            {/*
                            <Checkbox
                              iconStyle={{
                                fill: "#A3A3A3",
                                marginRight: "10px",
                              }}
                              defaultChecked={true}
                              onCheck={(e, isInputChecked) => {
                              }}
                              style={{ width: "30px" }}
                            />*/}
                            <div style={{ flexGrow: "1" }}>
                              {item.label}&nbsp;&nbsp;&nbsp;
                            </div>
                          </div>
                          <div
                            style={{
                              marginTop: "-10px",
                              overflow: "hidden",
                              borderBottom: "1px gray dashed",
                            }}
                          >
                            &nbsp;
                          </div>
                        </Col>
                        <Col
                          xs="2"
                          md="2"
                          sm="2"
                          lg="2"
                          className="text-right no-padding-right no-padding-left"
                          style={{ overflow: "hidden" }}
                          onMouseOver={this.onConfirmBtnMouseOver.bind(this)}
                        >
                          <div
                            style={{
                              marginTop: "-10px",
                              overflow: "hidden",
                              borderBottom: "1px gray dashed",
                            }}
                          >
                            &nbsp;
                          </div>
                        </Col>
                        <Col
                          xs="1"
                          sm="1"
                          md="1"
                          lg="1"
                          style={{
                            paddingLeft: "15px",
                            display: listMode === true ? "none" : "block",
                          }}
                        >
                          <a
                            onClick={(e) => {
                              this.removeStateAttribute(e, item);
                            }}
                          >
                            <i className="icon-cancel-circle2 text-teal-400" />
                          </a>
                        </Col>
                      </Row>
                    }
                    key={item.id}
                    isLeaf
                  />
                ))}
              </TreeNode>
              <TreeNode
                className={selected_city.length > 0 ? "" : "hidden-city"}
                title={
                  <Row
                    style={{ paddingTop: "2px" }}
                    className="no-margin-left no-margin-bottom no-padding-bottom no-padding-left pr-5"
                  >
                    <Col
                      xs="9"
                      md="9"
                      sm="9"
                      lg="9"
                      className="no-padding-right"
                      style={{ overflow: "hidden" }}
                    >
                      <div style={{ float: "left" }} data-type="city">
                        <span className="text-teal-400">City</span>
                        <span>({selected_city.length})</span>
                        &nbsp;&nbsp;&nbsp;
                      </div>
                      <div
                        style={{
                          marginTop: "-10px",
                          overflow: "hidden",
                          borderBottom: "1px gray dashed",
                        }}
                      >
                        &nbsp;
                      </div>
                    </Col>
                    <Col
                      xs="2"
                      md="2"
                      sm="2"
                      lg="2"
                      className="text-right no-padding-right no-padding-left"
                      style={{ overflow: "hidden" }}
                      onMouseOver={this.onConfirmBtnMouseOver.bind(this)}
                    >
                      <div
                        style={{
                          marginTop: "-10px",
                          overflow: "hidden",
                          borderBottom: "1px gray dashed",
                        }}
                      >
                        &nbsp;
                      </div>
                    </Col>
                    <Col
                      xs="1"
                      sm="1"
                      md="1"
                      lg="1"
                      style={{
                        paddingLeft: "15px",
                        display: listMode === true ? "none" : "block",
                      }}
                    >
                      <a onClick={(e) => this.removeAllCity(e)}>
                        <i className="icon-cancel-circle2 text-teal-400" />
                      </a>
                    </Col>
                  </Row>
                }
              >
                {selected_city.map((item, index) => (
                  <TreeNode
                    title={
                      <Row
                        style={{ paddingTop: "2px" }}
                        className="no-margin-bottom no-padding-bottom no-margin-left no-padding-left pr-5"
                      >
                        <Col
                          xs="9"
                          md="9"
                          sm="9"
                          lg="9"
                          className="no-padding-right"
                          style={{ overflow: "hidden" }}
                        >
                          <div
                            style={{ float: "left" }}
                            className="text-teal-400"
                            data-type="cityChild"
                            data-index={index}
                          >
                            {item.label}, {item.state}&nbsp;&nbsp;&nbsp;
                          </div>
                          <div
                            style={{
                              marginTop: "-10px",
                              overflow: "hidden",
                              borderBottom: "1px gray dashed",
                            }}
                          >
                            &nbsp;
                          </div>
                        </Col>
                        <Col
                          xs="2"
                          md="2"
                          sm="2"
                          lg="2"
                          className="text-right no-padding-right no-padding-left"
                          style={{ overflow: "hidden" }}
                          onMouseOver={this.onConfirmBtnMouseOver.bind(this)}
                        >
                          <div
                            style={{
                              marginTop: "-10px",
                              overflow: "hidden",
                              borderBottom: "1px gray dashed",
                            }}
                          >
                            &nbsp;
                          </div>
                        </Col>
                        <Col
                          xs="1"
                          sm="1"
                          md="1"
                          lg="1"
                          style={{
                            paddingLeft: "15px",
                            display: listMode === true ? "none" : "block",
                          }}
                        >
                          <a
                            onClick={(e) => {
                              this.removeCityAttribute(e, item);
                            }}
                          >
                            <i className="icon-cancel-circle2 text-teal-400" />
                          </a>
                        </Col>
                      </Row>
                    }
                    key={item.id}
                    isLeaf
                  />
                ))}
              </TreeNode>
              <TreeNode
                className={zipcode.length > 0 ? "" : "hidden-zipcode"}
                title={
                  <Row
                    style={{ paddingTop: "2px" }}
                    className="no-margin-left no-margin-bottom no-padding-bottom no-padding-left pr-5"
                  >
                    <Col
                      xs="9"
                      md="9"
                      sm="9"
                      lg="9"
                      className="no-padding-right"
                      style={{ overflow: "hidden" }}
                    >
                      <div style={{ float: "left" }} data-type="zipcode">
                        <span className="text-teal-400">Zip Code</span>
                        <span>({zipcode.length})</span>&nbsp;&nbsp;&nbsp;
                      </div>
                      <div
                        onMouseOver={this.onConfirmBtnMouseOver.bind(this)}
                        style={{
                          marginTop: "-10px",
                          overflow: "hidden",
                          borderBottom: "1px gray dashed",
                        }}
                      >
                        &nbsp;
                      </div>
                    </Col>
                    <Col
                      xs="2"
                      md="2"
                      sm="2"
                      lg="2"
                      className="text-right no-padding-right no-padding-left"
                      style={{ overflow: "hidden" }}
                      onMouseOver={this.onConfirmBtnMouseOver.bind(this)}
                    >
                      <div
                        style={{
                          marginTop: "-10px",
                          overflow: "hidden",
                          borderBottom: "1px gray dashed",
                        }}
                      >
                        &nbsp;
                      </div>
                    </Col>
                    <Col
                      xs="1"
                      md="1"
                      sm="1"
                      lg="1"
                      style={{
                        paddingLeft: "15px",
                        display: listMode === true ? "none" : "block",
                      }}
                    >
                      <a onClick={(e) => this.removeAllZipCode(e)}>
                        <i className="icon-cancel-circle2 text-teal-400" />
                      </a>
                    </Col>
                  </Row>
                }
              >
                {zipcode.map((item, index) => (
                  <TreeNode
                    title={
                      <Row
                        style={{ paddingTop: "2px" }}
                        className="no-margin-bottom no-padding-bottom no-margin-left no-padding-left pr-5"
                      >
                        <Col
                          xs="9"
                          md="9"
                          sm="9"
                          lg="9"
                          className="no-padding-right"
                          style={{ overflow: "hidden" }}
                        >
                          <div
                            style={{ float: "left" }}
                            className="text-teal-400"
                            data-type="zipcodeitem"
                            data-index={index}
                          >
                            {item.zipcode}&nbsp;&nbsp;&nbsp;
                          </div>
                          <div
                            style={{
                              marginTop: "-10px",
                              overflow: "hidden",
                              borderBottom: "1px gray dashed",
                            }}
                          >
                            &nbsp;
                          </div>
                        </Col>
                        <Col
                          xs="2"
                          md="2"
                          sm="2"
                          lg="2"
                          className="text-right no-padding-right no-padding-left"
                          style={{ overflow: "hidden" }}
                          onMouseOver={this.onConfirmBtnMouseOver.bind(this)}
                        >
                          <div
                            style={{
                              marginTop: "-10px",
                              overflow: "hidden",
                              borderBottom: "1px gray dashed",
                            }}
                          >
                            &nbsp;
                          </div>
                        </Col>
                        <Col
                          xs="1"
                          sm="1"
                          md="1"
                          lg="1"
                          style={{
                            paddingLeft: "15px",
                            display: listMode === true ? "none" : "block",
                          }}
                        >
                          <a
                            onClick={(e) => {
                              this.removeZipCode(e, item);
                            }}
                          >
                            <i className="icon-cancel-circle2 text-teal-400" />
                          </a>
                        </Col>
                      </Row>
                    }
                    key={index}
                    isLeaf
                  />
                ))}
              </TreeNode>
            </TreeNode>
            <TreeNode
              className={selected_county.length > 0 ? "" : "hidden-county"}
              title={
                <Row
                  style={{ paddingTop: "2px" }}
                  className="no-margin-left no-margin-bottom no-padding-bottom no-padding-left pr-5"
                >
                  <Col
                    xs="9"
                    md="9"
                    sm="9"
                    lg="9"
                    className="no-padding-right"
                    style={{ overflow: "hidden" }}
                  >
                    <div style={{ float: "left" }} data-type="county">
                      <span className="text-teal-400">County</span>
                      <span>({selected_county.length})</span>
                      &nbsp;&nbsp;&nbsp;
                    </div>
                    <div
                      onMouseOver={this.onConfirmBtnMouseOver.bind(this)}
                      style={{
                        marginTop: "-10px",
                        overflow: "hidden",
                        borderBottom: "1px gray dashed",
                      }}
                    >
                      &nbsp;
                    </div>
                  </Col>
                  <Col
                    xs="2"
                    md="2"
                    sm="2"
                    lg="2"
                    className="text-right no-padding-right no-padding-left"
                    style={{ overflow: "hidden" }}
                    onMouseOver={this.onConfirmBtnMouseOver.bind(this)}
                  >
                    <div
                      style={{
                        marginTop: "-10px",
                        overflow: "hidden",
                        borderBottom: "1px gray dashed",
                      }}
                    >
                      &nbsp;
                    </div>
                  </Col>
                  <Col
                    xs="1"
                    md="1"
                    sm="1"
                    lg="1"
                    style={{
                      paddingLeft: "15px",
                      display: listMode === true ? "none" : "block",
                    }}
                  >
                    <a onClick={(e) => this.removeAllCounty(e)}>
                      <i className="icon-cancel-circle2 text-teal-400" />
                    </a>
                  </Col>
                </Row>
              }
            >
              {selected_county.map((item, index) => (
                <TreeNode
                  title={
                    <Row
                      style={{ paddingTop: "2px" }}
                      className="no-margin-bottom no-padding-bottom no-margin-left no-padding-left pr-5"
                    >
                      <Col
                        xs="9"
                        md="9"
                        sm="9"
                        lg="9"
                        className="no-padding-right"
                        style={{ overflow: "hidden" }}
                      >
                        <div
                          style={{ float: "left" }}
                          className="text-teal-400"
                          data-type="countyItem"
                          data-index={index}
                        >
                          {item.label}&nbsp;&nbsp;&nbsp;
                        </div>
                        <div
                          style={{
                            marginTop: "-10px",
                            overflow: "hidden",
                            borderBottom: "1px gray dashed",
                          }}
                        >
                          &nbsp;
                        </div>
                      </Col>
                      <Col
                        xs="2"
                        md="2"
                        sm="2"
                        lg="2"
                        className="text-right no-padding-right no-padding-left"
                        style={{ overflow: "hidden" }}
                        onMouseOver={this.onConfirmBtnMouseOver.bind(this)}
                      >
                        <div
                          style={{
                            marginTop: "-10px",
                            overflow: "hidden",
                            borderBottom: "1px gray dashed",
                          }}
                        >
                          &nbsp;
                        </div>
                      </Col>
                      <Col
                        xs="1"
                        sm="1"
                        md="1"
                        lg="1"
                        style={{
                          paddingLeft: "15px",
                          display: listMode === true ? "none" : "block",
                        }}
                      >
                        <a
                          onClick={(e) => {
                            this.removeCounty(e, item);
                          }}
                        >
                          <i className="icon-cancel-circle2 text-teal-400" />
                        </a>
                      </Col>
                    </Row>
                  }
                  key={index}
                  isLeaf
                />
              ))}
            </TreeNode>
            <TreeNode
              className={selected_dma.length > 0 ? "" : "hidden-dma"}
              title={
                <Row
                  style={{ paddingTop: "2px" }}
                  className="no-margin-left no-margin-bottom no-padding-bottom no-padding-left pr-5"
                >
                  <Col
                    xs="9"
                    md="9"
                    sm="9"
                    lg="9"
                    className="no-padding-right"
                    style={{ overflow: "hidden" }}
                  >
                    <div style={{ float: "left" }} data-type="dma">
                      <span className="text-teal-400">DMA</span>
                      <span>({selected_dma.length})</span>
                      &nbsp;&nbsp;&nbsp;
                    </div>
                    <div
                      onMouseOver={this.onConfirmBtnMouseOver.bind(this)}
                      style={{
                        marginTop: "-10px",
                        overflow: "hidden",
                        borderBottom: "1px gray dashed",
                      }}
                    >
                      &nbsp;
                    </div>
                  </Col>
                  <Col
                    xs="2"
                    md="2"
                    sm="2"
                    lg="2"
                    className="text-right no-padding-right no-padding-left"
                    style={{ overflow: "hidden" }}
                    onMouseOver={this.onConfirmBtnMouseOver.bind(this)}
                  >
                    <div
                      style={{
                        marginTop: "-10px",
                        overflow: "hidden",
                        borderBottom: "1px gray dashed",
                      }}
                    >
                      &nbsp;
                    </div>
                  </Col>
                  <Col
                    xs="1"
                    md="1"
                    sm="1"
                    lg="1"
                    style={{
                      paddingLeft: "15px",
                      display: listMode === true ? "none" : "block",
                    }}
                  >
                    <a onClick={(e) => this.removeAllDMA(e)}>
                      <i className="icon-cancel-circle2 text-teal-400" />
                    </a>
                  </Col>
                </Row>
              }
            >
              {selected_dma.map((item, index) => (
                <TreeNode
                  title={
                    <Row
                      style={{ paddingTop: "2px" }}
                      className="no-margin-bottom no-padding-bottom no-margin-left no-padding-left pr-5"
                    >
                      <Col
                        xs="9"
                        md="9"
                        sm="9"
                        lg="9"
                        className="no-padding-right"
                        style={{ overflow: "hidden" }}
                      >
                        <div
                          style={{ float: "left" }}
                          className="text-teal-400"
                          data-type="dmaItem"
                          data-index={index}
                        >
                          {item.code} - {item.label}&nbsp;&nbsp;&nbsp;
                        </div>
                        <div
                          style={{
                            marginTop: "-10px",
                            overflow: "hidden",
                            borderBottom: "1px gray dashed",
                          }}
                        >
                          &nbsp;
                        </div>
                      </Col>
                      <Col
                        xs="2"
                        md="2"
                        sm="2"
                        lg="2"
                        className="text-right no-padding-right no-padding-left"
                        style={{ overflow: "hidden" }}
                        onMouseOver={this.onConfirmBtnMouseOver.bind(this)}
                      >
                        <div
                          style={{
                            marginTop: "-10px",
                            overflow: "hidden",
                            borderBottom: "1px gray dashed",
                          }}
                        >
                          &nbsp;
                        </div>
                      </Col>
                      <Col
                        xs="1"
                        sm="1"
                        md="1"
                        lg="1"
                        style={{
                          paddingLeft: "15px",
                          display: listMode === true ? "none" : "block",
                        }}
                      >
                        {
                          <a
                            onClick={(e) => {
                              this.removeDMA(e, item);
                            }}
                          >
                            <i className="icon-cancel-circle2 text-teal-400" />
                          </a>
                        }
                      </Col>
                    </Row>
                  }
                  key={index}
                  isLeaf
                />
              ))}
            </TreeNode>
          </Tree>
        </div>
      );
    }
  }
  render() {
    const display_categories = [];
    const {
      selectedAttrs,
      categories,
      hideTitle,
      plottedRadius,
      selected_state,
      selected_city,
      selected_county,
      selected_dma,
      zipcode,
    } = this.props;
    map(categories, (cat, key) => {
      const attrs = [];
      const auto_mm_attr_cols = [];
      let auto_mm_total_audience = 0;
      let auto_mm_total_count = 0;
      map(cat.attributes, (attr) => {
        let total_audience = 0;
        let total_count = 0;
        const cat_attr_cols = [];
        map(attr.values, (val) => {
          if (selectedAttrs.indexOf(val.id) >= 0) {
            const leafNode = (
              <TreeNode
                title={
                  <Row
                    style={{ marginLeft: "0px", paddingRight: "2px" }}
                    className="no-margin-bottom no-padding-bottom pt-5"
                  >
                    <Col
                      xs="9"
                      md="9"
                      sm="9"
                      lg="9"
                      className="no-padding-right"
                      style={{ overflow: "hidden" }}
                    >
                      <div style={{ float: "left" }} className="text-teal-400">
                        {val.label}&nbsp;&nbsp;&nbsp;
                      </div>
                      <div
                        onMouseOver={this.onConfirmBtnMouseOver.bind(this)}
                        style={{
                          marginTop: "-10px",
                          overflow: "hidden",
                          borderBottom: "1px gray dashed",
                        }}
                      >
                        &nbsp;
                      </div>
                    </Col>
                    <Col
                      xs="2"
                      md="2"
                      sm="2"
                      lg="2"
                      className="text-right no-padding-right no-padding-left"
                      style={{ overflow: "hidden" }}
                      onMouseOver={this.onConfirmBtnMouseOver.bind(this)}
                    >
                      <div
                        style={{
                          marginTop: "-10px",
                          overflow: "hidden",
                          borderBottom: "1px gray dashed",
                        }}
                      >
                        &nbsp;&nbsp;&nbsp;
                      </div>
                    </Col>
                    <Col
                      xs="1"
                      md="1"
                      sm="1"
                      lg="1"
                      style={{ paddingLeft: "15px" }}
                    >
                      {this.removeValBtn(val.id)}
                    </Col>
                  </Row>
                }
                key={cat.id + "-" + attr.id + "-" + val.id}
                isLeaf
              />
            );
            if (attr.id === 605 || attr.id === 606) {
              auto_mm_attr_cols.push(leafNode);
              auto_mm_total_audience += val.total;
              auto_mm_total_count += 1;
            } else {
              cat_attr_cols.push(leafNode);
              total_audience += val.total;
              total_count += 1;
            }
          }
        });
        map(attr.subAttributes, (subAttr) => {
          map(subAttr.values, (val) => {
            if (selectedAttrs.indexOf(val.id) >= 0) {
              cat_attr_cols.push(
                <TreeNode
                  title={
                    <Row
                      style={{ marginLeft: "0px", paddingRight: "2px" }}
                      className="no-margin-bottom no-padding-bottom pt-5"
                    >
                      <Col
                        xs="9"
                        md="9"
                        sm="9"
                        lg="9"
                        className="no-padding-right"
                        style={{ overflow: "hidden" }}
                      >
                        <div
                          style={{ float: "left" }}
                          className="text-teal-400"
                        >
                          {subAttr.name + ": " + val.label}&nbsp;&nbsp;&nbsp;
                        </div>
                        <div
                          onMouseOver={this.onConfirmBtnMouseOver.bind(this)}
                          style={{
                            marginTop: "-10px",
                            overflow: "hidden",
                            borderBottom: "1px gray dashed",
                          }}
                        >
                          &nbsp;
                        </div>
                      </Col>
                      <Col
                        xs="2"
                        md="2"
                        sm="2"
                        lg="2"
                        className="text-right no-padding-right no-padding-left"
                        style={{ overflow: "hidden" }}
                        onMouseOver={this.onConfirmBtnMouseOver.bind(this)}
                      >
                        <div
                          style={{
                            marginTop: "-10px",
                            overflow: "hidden",
                            borderBottom: "1px gray dashed",
                          }}
                        >
                          &nbsp;&nbsp;&nbsp;
                        </div>
                      </Col>
                      <Col
                        xs="1"
                        md="1"
                        sm="1"
                        lg="1"
                        style={{ paddingLeft: "15px" }}
                      >
                        {this.removeValBtn(val.id)}
                      </Col>
                    </Row>
                  }
                  key={cat.id + "-" + attr.id + "-" + subAttr.id + "-" + val.id}
                  isLeaf
                />,
              );
              total_audience += val.total;
              total_count += 1;
            }
          });
        });
        if (total_count > 0) {
          const name =
            total_count > 0 ? (
              [
                <span
                  key={"attribute_name_" + attr.id}
                  className="text-teal-400"
                >
                  {attr.name}
                </span>,
                <span key={"attribute_acount_" + attr.id}>
                  {" (" + total_count + ")"}
                </span>,
              ]
            ) : (
              <span key={"attribute_name_" + attr.id} className="text-teal-400">
                {" "}
                attr.name
              </span>
            );
          attrs.push(
            <TreeNode
              title={
                <Row
                  style={{
                    marginLeft: "0px",
                    paddingTop: "2px",
                    paddingLeft: "0px",
                  }}
                  className="no-margin-bottom no-padding-bottom no-padding-right"
                >
                  <Col
                    xs="9"
                    md="9"
                    sm="9"
                    lg="9"
                    className="no-padding-right"
                    style={{ overflow: "hidden" }}
                  >
                    <div style={{ float: "left" }}>
                      {name}&nbsp;&nbsp;&nbsp;
                    </div>
                    <div
                      onMouseOver={this.onConfirmBtnMouseOver.bind(this)}
                      style={{
                        marginTop: "-10px",
                        overflow: "hidden",
                        borderBottom: "1px gray dashed",
                      }}
                    >
                      &nbsp;
                    </div>
                  </Col>
                  <Col
                    xs="2"
                    md="2"
                    sm="2"
                    lg="2"
                    className="text-right no-padding-right no-padding-left"
                    style={{ overflow: "hidden" }}
                    onMouseOver={this.onConfirmBtnMouseOver.bind(this)}
                  >
                    <div
                      style={{
                        marginTop: "-10px",
                        overflow: "hidden",
                        borderBottom: "1px gray dashed",
                      }}
                    >
                      &nbsp;&nbsp;&nbsp;
                    </div>
                  </Col>
                  <Col
                    xs="1"
                    md="1"
                    sm="1"
                    lg="1"
                    style={{ paddingLeft: "15px" }}
                  >
                    {this.removeAttrValBtn(attr.id)}
                  </Col>
                </Row>
              }
              key={cat.id + "-" + attr.id}
              className={this.props.listMode === true ? "width-128" : ""}
            >
              {cat_attr_cols}
            </TreeNode>,
          );
        }
      });
      if (auto_mm_total_count > 0) {
        const name =
          auto_mm_total_count > 0 ? (
            [
              <span key={"attribute_name_605"} className="text-teal-400">
                {"Auto Make/Model"}
              </span>,
              <span key={"attribute_acount_605"}>
                {" (" + auto_mm_total_count + ")"}
              </span>,
            ]
          ) : (
            <span key={"attribute_name_605"} className="text-teal-400">
              Auto Make/Model
            </span>
          );
        attrs.push(
          <TreeNode
            title={
              <Row
                style={{
                  marginLeft: "0px",
                  paddingTop: "2px",
                  paddingLeft: "0px",
                }}
                className="no-margin-bottom no-padding-bottom no-padding-right"
              >
                <Col
                  xs="9"
                  md="9"
                  sm="9"
                  lg="9"
                  className="no-padding-right"
                  style={{ overflow: "hidden" }}
                >
                  <div style={{ float: "left" }}>{name}&nbsp;&nbsp;&nbsp;</div>
                  <div
                    onMouseOver={this.onConfirmBtnMouseOver.bind(this)}
                    style={{
                      marginTop: "-10px",
                      overflow: "hidden",
                      borderBottom: "1px gray dashed",
                    }}
                  >
                    &nbsp;
                  </div>
                </Col>
                <Col
                  xs="2"
                  md="2"
                  sm="2"
                  lg="2"
                  className="text-right no-padding-right no-padding-left"
                  style={{ overflow: "hidden" }}
                  onMouseOver={this.onConfirmBtnMouseOver.bind(this)}
                >
                  <div
                    style={{
                      marginTop: "-10px",
                      overflow: "hidden",
                      borderBottom: "1px gray dashed",
                    }}
                  >
                    &nbsp;&nbsp;&nbsp;
                  </div>
                </Col>
                <Col
                  xs="1"
                  md="1"
                  sm="1"
                  lg="1"
                  style={{ paddingLeft: "15px" }}
                >
                  {this.removeAttrValBtn(605)}
                </Col>
              </Row>
            }
            key={cat.id + "-605"}
          >
            {auto_mm_attr_cols}
          </TreeNode>,
        );
      }

      const cat_col = [
        <FullRow className="no-padding-bottom no-margin-bottom  no-padding-top no-margin-top">
          <h4 style={{ marginBottom: "0px" }}>{cat.name}</h4>
        </FullRow>,
        <Tree
          showIcon={false}
          selectable={false}
          showLine={false}
          checkable={false}
          defaultExpandAll={false}
          onMouseEnter={(info) => {
            this.displayAttrAudience(info, categories, selectedAttrs);
          }}
          onMouseLeave={this.onMouseLeave.bind(this)}
        >
          {attrs}
        </Tree>,
      ];

      if (attrs.length > 0) {
        display_categories.push(cat_col);
      }
    });

    let sltAttrCount = 0;
    if (selectedAttrs) sltAttrCount += selectedAttrs.length;
    if (!isEmpty(plottedRadius)) sltAttrCount += 1;
    sltAttrCount += selected_state.length;
    sltAttrCount += selected_city.length;
    if (selected_county) sltAttrCount += selected_county.length;
    if (selected_dma) sltAttrCount += selected_dma.length;
    sltAttrCount += zipcode.length;
    return (
      <div
        className={
          this.props.listMode === true
            ? "pl-10 pr-20 selected-values-container"
            : "pl-20 pr-20 selected-values-container"
        }
      >
        {!this.props.listMode && (
          <FullRow
            style={{
              marginBottom: "-20px",
              display: hideTitle === true ? "none" : "inherited",
            }}
          >
            <p>Client: {this.props.selected_client_name}</p>
            <h3>You have added {sltAttrCount} Attributes to this segment</h3>
            <hr />
          </FullRow>
        )}
        <div
          className="panel panel-flat no-border no-shadow no-border-radius no-margin-bottom font-1em"
          style={{
            maxHeight: "300px",
            height: "300px",
            overflowX: "hidden",
            overflowY: "auto",
            backgroundColor: "transparent",
          }}
        >
          <Popover
            open={this.state.removeValConfirm}
            anchorEl={this.state.anchorEl}
            anchorOrigin={{ horizontal: "right", vertical: "top" }}
            targetOrigin={{ horizontal: "left", vertical: "center" }}
            onRequestClose={this.handleRemoveValConfirm.bind(this)}
            style={{ marginLeft: "10px" }}
          >
            <FullRow className="text-default">
              Are you sure you want to remove
              <br />
              this attribute?
              <br />
              <br />
              <a
                style={{ marginRight: "15px", marginLeft: "-15px" }}
                className="btn btn-link btn-sm text-teal-400 "
                onClick={(e) => {
                  this.handleRemoveValConfirm();
                }}
              >
                Cancel
              </a>
              <a
                className="btn btn-aa-default btn-default btn-round btn-sm bg-grey text-white "
                onClick={(e) => {
                  this.removeSelectVal();
                  this.handleRemoveValConfirm();
                }}
              >
                Yes, remove
              </a>
            </FullRow>
          </Popover>
          {this.display_geography()}
          {this.plotted_radius_row()}
          {display_categories}
        </div>
      </div>
    );
  }
}

SelectedAttrs.propTypes = {
  removeAttribute: PropTypes.func,
};
SelectedAttrs.defaultProps = {
  selected_dma: [],
  selected_county: [],
};
export default SelectedAttrs;



// WEBPACK FOOTER //
// ./src/components/Segment/SelectedAttrs.js